import Button from '@components/Button';
import Column from '@components/Column';
import Text from '@components/Text';
import ModalContainer from '@modals/ModalContainer';
import { useFlow } from '@router/stackflow';
import { Modal } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

const NickNameChangeModal: ActivityComponentType = () => {
  const { pop } = useFlow();
  return (
        <Modal>
            <ModalContainer>
                <Column fullWidth align='center'
                        spacing={24} >
                    <Text size='xl'>변경되었습니다.</Text>
                    <Button onClick={pop}
                            fullWidth >
                        확인
                    </Button>
                </Column>
            </ModalContainer>
        </Modal>
  );
};

export default NickNameChangeModal;
